[<RequireQualifiedAccess>]
module Header

open Shared
open ViewTypes
open Feliz
open System
open ViewTypes
open API




let levelLogo state (dispatch: Msg -> unit)  =
    Html.div [ prop.className "level-left"
               prop.children [ Html.div [ prop.className "level-item button"
                                          prop.onClick (fun _ -> dispatch LogoClicked)
                                          prop.children [ Html.img [ prop.src "/bandlogo.png" ] ] ] ] ]

let levelTitle () =
    Html.h1 [ prop.className "level-item title"
              prop.text "Imposters" ]

let headLine state (dispatch: Msg -> unit) =
    let hamburgerIcon =
        if state.ShowSideBar then "fa fa-times" else "fa fa-bars"

    let hamburger =
        Html.div [ prop.className "level-right"
                   prop.children [ Html.button [ prop.className "button is-hidden-tablet"
                                                 prop.onClick (fun _ -> dispatch (HamBurgerClicked))
                                                 prop.children [ Html.i [ prop.className hamburgerIcon ] ] ]
         ] ]

    Html.section [ Html.nav [ prop.className "level navbar has-shadow is-spaced is-white"
                              prop.children [ levelLogo state dispatch
                                              levelTitle ()
                                              hamburger
                                              //selectButton items dispatch
                                              ] ] ]

let header (state: State) (dispatch: Msg -> unit) = headLine state dispatch
